module.exports = __webpack_public_path__ + "img/marisol-icono-estatico.b2e2107b.png";